export default __webpack_public_path__ + "static/media/linkedin.66ffd29a.png";